<template>
  <ListView
    :isFluid="true"
    :title="title"
    @reload="reload"
    @create="actionCreate"
    @navDetails="actionDetails"
    :sort.sync="sort"
    :enable-create="true"
    :search.sync="search"
    :data="data"
    :limit="limit"
    :page.sync="page"
    :header="computedHeader"
    :showSummary="true"
    :search-box-placeholder="searchBoxPlaceholder"
  >
    <!-- <template v-slot:listHeader>
      <div class="d-flex align-center mb-8 flex-gap">
        <h2>{{ title }}</h2>
        <div class="flex-grow-1">
          <fletrix-text-field icon="mdi-magnify" v-model="search" placeholder="Search" />
        </div>
        <div class="body-2 primary--text font-weight-bold">Items:</div>
        <div style="width: 5.5rem">
          <v-select :items="limitOption" v-model="selectedLimit" hide-details="auto" dense outlined>
          </v-select>
        </div>
        <div style="width: 8rem">
          <v-select
            v-model="selectedStatus"
            :items="profileStatuses"
            hide-details="auto"
            dense
            outlined
          >
          </v-select>
        </div>
        <v-btn v-if="selectedRole === roles.client" @click="mergeAccount" outlined color="primary">
          Merge Account
        </v-btn>
        <v-btn @click="actionCreate" color="primary">
          <v-icon>mdi-plus-thick</v-icon>
          Add New
        </v-btn>
      </div>
    </template> -->
    <template v-slot:card="{ cardContent }">
      <Card :content="cardContent" class="clickable" @click.native="actionDetails(cardContent)" />
    </template>
    <template v-slot:item.phone="{ item }">
      {{ item.phone | displayPhone }}
    </template>
    <template v-slot:item.phone2="{ item }">
      {{ item.phone2 }}
    </template>

    <template v-slot:item.gender="{ item }">
      <gender-label :gender="item.gender" class="mr-1" />
    </template>

    <template v-slot:item._numberOfPatient="{ item }">
      {{ get(item, 'patients.length', 0) }}
    </template>
    <template v-slot:item.remarks="{ item }">
      {{ item.remarks || '-' }}
    </template>

    <template v-slot:item.onDutyDay="{ item }">
      <div class="d-flex flex-gap-xs">
        <v-chip :key="day" small v-for="day in item.onDutyDay" color="#C7A0CB80">{{ day }}</v-chip>
      </div>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip
        class="statusChip"
        label
        color="status_active"
        v-if="item.status === ProfileStatus.accepted"
      >
        Active
      </v-chip>
      <v-chip class="statusChip" label v-else> Inactive </v-chip>
    </template>
    <template v-slot:item.medicalType="{ item }">
      {{ getClinicServiceText(item.medicalType) }}
    </template>
    <template v-slot:item.name="{ item }">
      {{ formatProfileName(item) }}
    </template>
    <!-- <template v-if="selectedRole === 'bn.master'" v-slot:filterRight>
      <div style="width: 200px">
        <v-select
          v-model="selectedStatus"
          :items="profileStatuses"
          item-value="value"
          item-text="text"
          clearable
          flat
          label="Status"
          outlined
        />
      </div>
    </template> -->
    <!-- <PatientEditFormPopup
      v-model="editDialog"
      v-if="this.selectedRole === roles.client"
      @create="reload"
      @update="reload"
      @delete="reload"
    /> -->

    <IdentityEditDialog
      v-model="editDialog"
      :id="editId"
      :title="title"
      :role="selectedRole"
      @create="reload"
      @update="reload"
      @delete="reload"
    />
  </ListView>
</template>

<script>
import GenderLabel from '@/components/GenderLabel.vue';
import listViewPageMixin from '@/services/listViewPageMixin';
import Card from '@/components/Identity/IdentityCard';
import IdentityEditDialog from '@/components/Identity/IdentityEditDialog';
import { mapGetters } from 'vuex';
import { RESTFUL, roles } from '@/data/constants';
import { decapitalize, translateOptions, formatProfileName } from '@/services/filters';
import { month, roleOptions, clinicServiceOption } from '@/data/optionsConstants';
import { ProfileStatus } from '@/api/auth/membership';
import { relatedAccountsPopulate } from '@/api/auth/membership';
import { get } from 'lodash';

export default {
  name: 'profiles',
  props: {
    selectedRole: {},
  },
  mixins: [listViewPageMixin],
  components: {
    IdentityEditDialog,
    Card,
    GenderLabel,
  },
  data() {
    return {
      roles,
      ProfileStatus,
      month: month,
      header: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Sid', value: 'sid', sortable: false },
        { text: 'status', value: 'status', sortable: false },
      ],
      birthday: null,
      selectedStatus: ProfileStatus.accepted,
      populate: [relatedAccountsPopulate],
    };
  },
  computed: {
    ...mapGetters('auth', ['role', 'isAdmin', 'isClinicStaff', 'isCashier']),
    restfulURL() {
      let out = RESTFUL.profile.list;

      if (this.selectedRole === roles.admin) {
        out = RESTFUL.adminProfile.list;
      }
      if (this.selectedRole === roles.member) {
        out = RESTFUL.clientProfile.list;
      } else if (this.selectedRole === roles.doctor) {
        out = this.isClinicStaff
          ? RESTFUL.masterProfile.masterList
          : this.isCashier
          ? RESTFUL.masterProfile.cashierList
          : RESTFUL.masterProfile.list;
      } else if (this.selectedRole === roles.clinicStaff) {
        out = this.isClinicStaff
          ? RESTFUL.cashierProfile.masterList
          : this.isCashier
          ? RESTFUL.cashierProfile.cashierList
          : RESTFUL.cashierProfile.list;
      } else if (this.selectedRole === roles.clinic) {
        out = this.isAdmin ? RESTFUL.dispenserProfile.list : RESTFUL.dispenserProfile.staffList;
      }
      return out;
    },
    computedHeader() {
      switch (this.selectedRole) {
        case roles.member:
          return [
            ...this.header,
            { text: 'Account no.', value: 'phone', sortable: false },
            { text: 'Number of patient', value: '_numberOfPatient', sortable: false },
            { text: 'Remarks', value: 'remarks', sortable: false },
          ];
        case roles.doctor:
          return [
            { text: 'Staff ID', value: 'sid', sortable: false },
            { text: 'Medical Type', value: 'medicalType', sortable: false },
            ...this.header,
            { text: 'On-Duty Day', value: 'onDutyDay', sortable: false },
            { text: 'Status', value: 'status' },
          ];
        case roles.clinicStaff:
          return [
            { text: 'Staff ID', value: 'sid', sortable: false },
            ...this.header,
            { text: 'On-Duty Day', value: 'onDutyDay', sortable: false },
            { text: 'Status', value: 'status' },
          ];
        default:
          return this.header;
      }
    },
    filter() {
      return {
        //role: this.selectedRole || null,
        // birthday: this.birthday && this.selectedRole === 'rml.client' ? this.birthday : undefined,
        status: this.selectedStatus ? this.selectedStatus : undefined,
      };
    },
    mergeParams() {
      return {
        searchFirstRelatedAccount: true,
      };
    },
    title() {
      return this.selectedRole ? `${translateOptions(this.selectedRole, roleOptions)}` : `Accounts`;
      // return this.selectedRole
      //   ? `Accounts-${translateOptions(this.selectedRole, roleOptions)}`
      //   : `Accounts`;
    },
    profileStatuses() {
      return [
        { text: 'All', value: null },
        { text: 'Active', value: ProfileStatus.accepted },
        { text: 'Inactive', value: ProfileStatus.rejected },
      ];
    },
    searchBoxPlaceholder() {
      if (this.selectedRole === roles.member) {
        return 'Search by Name/ Sid/ Phone No./ Contact No.';
      }
      if (this.selectedRole === roles.admin) {
        return 'Search by Name/ Phone No.';
      }
    },
  },
  methods: {
    get,
    formatProfileName,
    getClinicServiceText(value) {
      return clinicServiceOption.find(item => item.value === value)?.text || '';
    },
  },
};
</script>

<style scoped lang="scss">
.selectedItem ::v-deep .v-select__selection--comma {
  margin-bottom: -25px;
}

.role {
  top: 10px;
  position: absolute;
  left: 24px;
  color: var(--v-success-base);
}
</style>
